import { STHead } from "@/components";
import { STOurTechnology } from "@/components/STOurTechnology";
import React from "react";

const OurTechnology = () => {
  return (
    <>
      <STHead
        title="Our Technology"
        description="100% bio-based mono-material coating for high grease barrier, water vapour and water barrier in a single-layer for paper packaging."
        keywords="Sustanix technology, green chemistry, sustainable additives, innovation"
        canonicalUrl="https://sustanix.com/our-technology/"
        ogTitle="100% bio-based barrier coatings for paper packaging"
        ogDescription="Water, Grease & Water Vapour barrier in one layer through plant-based monomaterial coating technology"
        ogKeywords="Sustanix technology, green chemistry, sustainable additives, innovation"
        ogUrl="https://sustanix.com/our-technology/"
        ogImage="https://sustanix.com/opengraph-image.webp"
        ogType="website"
      />
      <STOurTechnology />
    </>
  );
};

export default OurTechnology;
